export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7274.22bf460d.jpg";